module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "rtitle flex justify-between align-center bg-white rone"
  }, [_c('div', {
    staticClass: "colorleft"
  }, [_vm._v("企业服务")]), _vm._v(" "), _c('div', {
    staticClass: "colorright"
  }, [_c('div', {
    staticClass: "t_btn pointer",
    on: {
      "click": _vm.tolist
    }
  }, [_vm._v("需求记录")])])]), _vm._v(" "), _c('div', {
    staticClass: "cball"
  }, [_c('div', {
    staticClass: "bg-white",
    staticStyle: {
      "min-height": "570px",
      "padding": "20px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "t_brief"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("① 维修需求请附加照片内容")]), _vm._v(" "), _c('div', [_vm._v("② 借用会议室，请提出借用名称、借用时间、借用时长")])])])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "25px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "650px",
      "margin": "0 auto"
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "model": _vm.cominfo,
      "rules": _vm.rules,
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "标题：",
      "prop": "title"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "420px"
    },
    attrs: {
      "placeholder": "请输入",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.cominfo.title),
      callback: function($$v) {
        _vm.$set(_vm.cominfo, "title", $$v)
      },
      expression: "cominfo.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "申请简述：",
      "prop": "content"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "420px"
    },
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "请输入咨询内容",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.cominfo.content),
      callback: function($$v) {
        _vm.$set(_vm.cominfo, "content", $$v)
      },
      expression: "cominfo.content"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "图片：",
      "prop": "file"
    }
  }, [_c('el-upload', {
    attrs: {
      "action": _vm.action,
      "list-type": "picture-card",
      "on-remove": _vm.handleRemove,
      "on-success": _vm.Successone,
      "file-list": _vm.cominfo.file
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.substatus
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("提交申请")])], 1)], 1)], 1)])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a73fd680"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/mine/apply.vue
// module id = 416
// module chunks = 1